<mat-list-item
  [class.active]="activated"
  [matTooltip]="channel.displayName"
  matTooltipPosition="after"
>
  <sn-channel-status mat-list-icon [channel]="channel" class="channel-icon"></sn-channel-status>
  <span class="truncate-text">{{ channel.displayName }}</span>
  <span [snBadge]="unconsumedMessagesCount" snBadgeInline snBadgeColor="danger"></span>
</mat-list-item>
